import { render, staticRenderFns } from "./WDSCategorySelector.vue?vue&type=template&id=142915ff&scoped=true"
import script from "./WDSCategorySelector.vue?vue&type=script&lang=js"
export * from "./WDSCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./WDSCategorySelector.vue?vue&type=style&index=0&id=142915ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142915ff",
  null
  
)

export default component.exports